import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("./Home"));

export const homeRoute: RouteObject = {
  path: "/",
  children: [{ path: "", Component: HomePage }],
};
